import {Pipe, PipeTransform} from '@angular/core';
import {formatDate} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

/**
 * @description Formats a date like Angular's date pipe, but in the language currently selected in the UI instead of
 * the fixed LOCALE_ID. Impure, so that it follows a language change without a reload; the last result is cached
 * per value, format and language. The locale data of every supported language is registered in the AppModule.
 */
@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  public static readonly supportedLocales = ['de', 'en', 'fr', 'nl'];
  private static readonly fallbackLocale = 'en';

  private lastValue: Date | string | number;
  private lastFormat: string;
  private lastLocale: string;
  private lastResult: string | null = null;

  constructor(private _translateService: TranslateService) {
  }

  transform(value: Date | string | number | null | undefined, format = 'mediumDate'): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const locale = this._currentLocale();
    if (value !== this.lastValue || format !== this.lastFormat || locale !== this.lastLocale) {
      this.lastValue = value;
      this.lastFormat = format;
      this.lastLocale = locale;
      this.lastResult = formatDate(value, format, locale);
    }
    return this.lastResult;
  }

  private _currentLocale(): string {
    const language = this._translateService.currentLang ?? this._translateService.defaultLang;
    return LocalizedDatePipe.supportedLocales.includes(language) ? language : LocalizedDatePipe.fallbackLocale;
  }

}
